import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { ConsentManagementEmailAddressApi } from './ModelsConsentManagementEmailAddressApi';
import { ConsentManagementPhoneApi } from './ModelsConsentManagementPhoneApi';

/**
 * APIL Url: ADAC.Internet.Core.Models.ConsentWriteShortModel
 * kurzes Model für die Datenverwendung in den Anträgen
 * Endpoints: /api/v2/versicherungen/fahrrad/anlage, /api/haustier/anlage, /api/mitgliedschaft, /api/mitgliedschaft/younggeneration, /api/mitgliedschaft/finanzdienste/kreditkarte, /api/mitgliedschaft/finanzdienste/modulkreditkarte, /api/mitgliedschaft/finanzdienste/autokredit, /api/mitgliedschaft/versicherungen/auto, /api/mitgliedschaft/profiwerber/agw, /api/ps/anlage, /api/rrv/anlage, /api/us/anlage, /api/versicherungen/aksbep/anlage, /api/versicherungen/akslangzeit/anlage, /api/versicherungen/incoming/anlage, /api/versicherungen/brs/anlage, /api/versicherungen/phv/anlage, /api/versicherungen/us/anlage, /api/versicherungen/ps/anlage, /api/v2/versicherungen/rrv/anlage, /api/zuhause/hausrat/anlage, /api/zuhause/schutzbrief/anlage
 */
export class ConsentWriteShortModelApi extends BaseApiModel {
	constructor(initialProperties?: Partial<ConsentWriteShortModelApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected herkunftskennzeichen: string;
	/**
	 * Description: Herkunftskennzeichen des Consents
	 * APIL Type: string
	 */
	get Herkunftskennzeichen(): string {
		return this.herkunftskennzeichen;
	}

	/**
	 * Description: Herkunftskennzeichen des Consents
	 * APIL Type: string
	 */
	set Herkunftskennzeichen(value: string) {
		this.herkunftskennzeichen = value;
	}

	protected ipAddress: string;
	/**
	 * Description: IP Adresse
	 * APIL Type: string
	 */
	get IpAddress(): string {
		return this.ipAddress;
	}

	/**
	 * Description: IP Adresse
	 * APIL Type: string
	 */
	set IpAddress(value: string) {
		this.ipAddress = value;
	}

	protected channelEmail: ConsentManagementEmailAddressApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.ConsentManagementEmailAddress
	 */
	get ChannelEmail(): ConsentManagementEmailAddressApi {
		return this.channelEmail;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.ConsentManagementEmailAddress
	 */
	set ChannelEmail(value: ConsentManagementEmailAddressApi) {
		this.channelEmail = value;
	}

	protected channelTel1: ConsentManagementPhoneApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.ConsentManagementPhone
	 */
	get ChannelTel1(): ConsentManagementPhoneApi {
		return this.channelTel1;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.ConsentManagementPhone
	 */
	set ChannelTel1(value: ConsentManagementPhoneApi) {
		this.channelTel1 = value;
	}

	protected channelTel2: ConsentManagementPhoneApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.ConsentManagementPhone
	 */
	get ChannelTel2(): ConsentManagementPhoneApi {
		return this.channelTel2;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Core.Models.ConsentManagementPhone
	 */
	set ChannelTel2(value: ConsentManagementPhoneApi) {
		this.channelTel2 = value;
	}

	protected trackingAuthorized: boolean;
	/**
	 * Description: Zustimmung zum Tracking
	 * APIL Type: boolean
	 */
	get TrackingAuthorized(): boolean {
		return this.trackingAuthorized;
	}

	/**
	 * Description: Zustimmung zum Tracking
	 * APIL Type: boolean
	 */
	set TrackingAuthorized(value: boolean) {
		this.trackingAuthorized = value;
	}

	protected version: string;
	/**
	 * Description: Version der Zustimmungserklärung, z. B. 06
	 * APIL Type: string
	 */
	get Version(): string {
		return this.version;
	}

	/**
	 * Description: Version der Zustimmungserklärung, z. B. 06
	 * APIL Type: string
	 */
	set Version(value: string) {
		this.version = value;
	}

	protected trackingVersion: string;
	/**
	 * Description: Version, für die das Einverständnis zum Tracking eingeholt wird, z. B. 01
	 * APIL Type: string
	 */
	get TrackingVersion(): string {
		return this.trackingVersion;
	}

	/**
	 * Description: Version, für die das Einverständnis zum Tracking eingeholt wird, z. B. 01
	 * APIL Type: string
	 */
	set TrackingVersion(value: string) {
		this.trackingVersion = value;
	}

	protected trackingReferenzId: string;
	/**
	 * Description: ReferenzId, die für den API-Zugriff auf das Thema Tracking in BSI-CRM konfiguriert ist.
	 * APIL Type: string
	 */
	get TrackingReferenzId(): string {
		return this.trackingReferenzId;
	}

	/**
	 * Description: ReferenzId, die für den API-Zugriff auf das Thema Tracking in BSI-CRM konfiguriert ist.
	 * APIL Type: string
	 */
	set TrackingReferenzId(value: string) {
		this.trackingReferenzId = value;
	}

	protected gesellschaftsId: string;
	/**
	 * Description: Kennung der Gesellschaft des ADAC, die das Einverständnis eingeholt wird, z. B. 0020
	 * APIL Type: string
	 */
	get GesellschaftsId(): string {
		return this.gesellschaftsId;
	}

	/**
	 * Description: Kennung der Gesellschaft des ADAC, die das Einverständnis eingeholt wird, z. B. 0020
	 * APIL Type: string
	 */
	set GesellschaftsId(value: string) {
		this.gesellschaftsId = value;
	}

	protected gesellschaftsname: string;
	/**
	 * Description: Name der Gesellschaft des ADAC, die das Einverständnis eingeholt wird, z. B. 0020
	 * APIL Type: string
	 */
	get Gesellschaftsname(): string {
		return this.gesellschaftsname;
	}

	/**
	 * Description: Name der Gesellschaft des ADAC, die das Einverständnis eingeholt wird, z. B. 0020
	 * APIL Type: string
	 */
	set Gesellschaftsname(value: string) {
		this.gesellschaftsname = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): ConsentWriteShortModelApi {
		return AppUtils.Helper.createFromMap(dataObject, ConsentWriteShortModelApi, (key, value) => {
			switch (key.toLowerCase()) {
				case 'channelemail':
					return ConsentManagementEmailAddressApi.createFromObject(value);
				case 'channeltel1':
					return ConsentManagementPhoneApi.createFromObject(value);
				case 'channeltel2':
					return ConsentManagementPhoneApi.createFromObject(value);
				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Herkunftskennzeichen = this.herkunftskennzeichen;
		result.IpAddress = this.ipAddress;
		if (this.channelEmail) {
			result.ChannelEmail = this.channelEmail.toRequestObject();
		}
		if (this.channelTel1) {
			result.ChannelTel1 = this.channelTel1.toRequestObject();
		}
		if (this.channelTel2) {
			result.ChannelTel2 = this.channelTel2.toRequestObject();
		}
		result.TrackingAuthorized = this.trackingAuthorized;
		result.Version = this.version;
		result.TrackingVersion = this.trackingVersion;
		result.TrackingReferenzId = this.trackingReferenzId;
		result.GesellschaftsId = this.gesellschaftsId;
		result.Gesellschaftsname = this.gesellschaftsname;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}